import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledShowOnRowHover = styled.div`
`

const ShowOnRowHover = ({ className, children }) => {
  return (
    <StyledShowOnRowHover className={className}>
      {children}
    </StyledShowOnRowHover>
  )
}

ShowOnRowHover.propTypes = {
  children: PropTypes.node,
}

export default ShowOnRowHover
